var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999939 7C0.447654 7 -6.10352e-05 7.44772 -6.10352e-05 8C-6.10352e-05 8.55228 0.447654 9 0.999939 9V7ZM28.585 8.70711C28.9755 8.31658 28.9755 7.68342 28.585 7.29289L22.221 0.928932C21.8305 0.538408 21.1973 0.538408 20.8068 0.928932C20.4163 1.31946 20.4163 1.95262 20.8068 2.34315L26.4637 8L20.8068 13.6569C20.4163 14.0474 20.4163 14.6805 20.8068 15.0711C21.1973 15.4616 21.8305 15.4616 22.221 15.0711L28.585 8.70711ZM0.999939 9L27.8779 9V7L0.999939 7V9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/long-arrow.093d4df3008e1a3dd680a9cc1bacfd3e.svg";
export { ForwardRef as ReactComponent };